(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@fe/extend'), require('dayjs'), require('@fe/utils'), require('@fe/calc')) :
    typeof define === 'function' && define.amd ? define(['exports', '@fe/extend', 'dayjs', '@fe/utils', '@fe/calc'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.filter = {}, global.extend, global.dayjs, global.utils, global.calc));
}(this, (function (exports, extend, dayjs, utils, calc) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);
    var calc__default = /*#__PURE__*/_interopDefaultLegacy(calc);

    /**
     * 通用状态字典 过滤器 将键值转换为label显示
     * @param value key
     * @param dictList 字典数组
     */
    var valueToLabel = function (value, dictList) {
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        var item = dictList.filter(function (el) { return el.value.toString() === value.toString(); });
        if (item.length > 0) {
            return item[0].label;
        }
        else {
            return value;
        }
    };
    /**
     * 通用状态字典 过滤器 将键值转换为label显示
     * @param value key
     * @param dictList 字典数组
     */
    var dictEscape = function (value, dictList) {
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        var item = dictList.filter(function (el) { return el.value.toString() === value.toString(); });
        if (item.length > 0) {
            return item[0].label;
        }
        else {
            return value;
        }
    };
    /**
     * 千分位 过滤器
     * @param value key
     * @param precision 保留几位小数
     * @param fillZero 实际小数位小于precision时 是否补零
     * @param separator 分隔符
     */
    var thousands = function (value, precision, fillZero, separator) {
        if (precision === void 0) { precision = 2; }
        if (fillZero === void 0) { fillZero = true; }
        if (separator === void 0) { separator = ','; }
        var num = Number(value);
        // 判断是否为数字
        if (utils.isNumber(num)) {
            var numStr = '';
            if (utils.isNumber(precision)) {
                if (fillZero) {
                    numStr = num.toFixedNew(precision).toString();
                }
                else {
                    var decimals = String(num).split('.')[1];
                    decimals = decimals ? decimals.length : 0;
                    if (decimals > precision) {
                        decimals = precision;
                    }
                    numStr = num.toFixedNew(decimals).toString();
                }
            }
            else {
                numStr = num.toString();
            }
            var parts = numStr.split('.');
            parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','));
            return parts.join('.');
        }
        return value;
    };
    /**
     * 数字精确位数 过滤器
     * @param value key
     * @param precision 保留几位小数
     */
    var toFixed = function (value, precision, fillZero) {
        if (precision === void 0) { precision = 2; }
        if (fillZero === void 0) { fillZero = true; }
        var num = Number(value);
        if (utils.isNumber(num)) {
            if (utils.isNumber(precision)) {
                if (fillZero) {
                    return num.toFixedNew(precision);
                }
                else {
                    var decimals = String(num).split('.')[1];
                    decimals = decimals ? decimals.length : 0;
                    if (decimals > precision) {
                        decimals = precision;
                    }
                    return num.toFixedNew(decimals);
                }
            }
            else {
                return num.toFixedNew(2);
            }
        }
        return value;
    };
    /**
     * 时间差转换 倒计时 过滤器
     * @param value key
     */
    var countDown = function (value) {
        if (utils.isNumber(value)) {
            if (value == 0) {
                return '00:00:00';
            }
            var hour = Math.floor(value / 3600);
            var minute = Math.floor((value - hour * 3600) / 60);
            var second = Math.floor(value - hour * 3600 - minute * 60);
            var hourStr = hour < 10 ? '0' + hour : hour;
            var minuteStr = minute < 10 ? '0' + minute : minute;
            var secondStr = second < 10 ? '0' + second : second;
            return hourStr + ':' + minuteStr + ':' + secondStr;
        }
        else {
            return value;
        }
    };
    /**
     * 时间转换过滤器 依赖dayjs
     * @param value key
     * @param format 格式化样式YYYY-MM-DD HH:mm:ss.SSS A (dayjs的format)
     */
    var dateFormat = function (value, format) {
        if (format === void 0) { format = 'YYYY-MM-DD HH:mm:ss'; }
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        if (value === 0 || value === '0')
            return '';
        if (!dayjs__default['default'](value).isValid())
            return '';
        return dayjs__default['default'](value).format(format);
    };
    /**
     * 银行卡脱敏打*号 只展示后几位
     * @param value key
     * @param endLen 尾部保留显示位数
     * @param total 银行卡脱敏替换后总长度
     */
    var bankSen = function (value, endLen, total) {
        if (endLen === void 0) { endLen = 4; }
        if (total === void 0) { total = 16; }
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        var xing = '';
        for (var i = 0; i < total - endLen; i++) {
            xing += '*';
        }
        return xing + value.substr(value.length - 4);
    };
    /**
     * 身份证脱敏打*号
     * @param value
     * @param frontLen 开头保留位数
     * @param endLen 尾部保留位数
     */
    var idCardSen = function (value, frontLen, endLen) {
        if (frontLen === void 0) { frontLen = 4; }
        if (endLen === void 0) { endLen = 4; }
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        if (value) {
            var len = value.length - frontLen - endLen;
            var xing = '';
            for (var i = 0; i < len; i++) {
                xing += '*';
            }
            return value.substring(0, frontLen) + xing + value.substring(value.length - endLen);
        }
        else {
            return '';
        }
    };
    /**
     * 金额转大写
     * @param value key
     */
    var bigMoney = function (value) {
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        value = Number(value);
        if (!utils.isNumber(value)) {
            return value;
        }
        if (value === 0) {
            return '零元整';
        }
        var fraction = ['角', '分'];
        var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
        var unit = [
            ['元', '万', '亿'],
            ['', '拾', '佰', '仟']
        ];
        var head = value < 0 ? '欠' : '';
        value = Math.abs(value);
        var s = '';
        for (var m = 0; m < fraction.length; m++) {
            s += (digit[Math.floor(calc__default['default'].multiply(value, 10 * Math.pow(10, m))) % 10] + fraction[m]).replace(/零./, '');
        }
        s = s || '整';
        value = Math.floor(value);
        for (var i = 0; i < unit[0].length && value > 0; i++) {
            var p = '';
            for (var j = 0; j < unit[1].length && value > 0; j++) {
                p = digit[value % 10] + unit[1][j] + p;
                value = Math.floor(value / 10);
            }
            s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
        }
        return (head +
            s
                .replace(/(零.)*零元/, '元')
                .replace(/(零.)+/g, '零')
                .replace(/^整$/, '零元整'));
    };
    /**
     * 将逗号分隔的字符串转为制定格式
     * @示例 splitFormat("1,2,3,4","个月",",")  转换结果为=>1个月,2个月,3个月,4个月
     * @param value key
     * @param addstr 拼接字符
     * @param separator 分割字符
     */
    var splitFormat = function (value, addstr, separator) {
        if (addstr === void 0) { addstr = ''; }
        if (separator === void 0) { separator = ','; }
        if (value === '' || utils.isNull(value) || utils.isUndefined(value)) {
            return value;
        }
        var arr = value.split(separator);
        arr = arr.map(function (el) { return el + addstr; });
        return arr.join(',');
    };

    exports.bankSen = bankSen;
    exports.bigMoney = bigMoney;
    exports.countDown = countDown;
    exports.dateFormat = dateFormat;
    exports.dictEscape = dictEscape;
    exports.idCardSen = idCardSen;
    exports.splitFormat = splitFormat;
    exports.thousands = thousands;
    exports.toFixed = toFixed;
    exports.valueToLabel = valueToLabel;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
